export const ticketsConstants = {
  SET_TICKETS_SUCCESS: 'SET_TICKETS_SUCCESS',
  SET_TICKETS_FAILURE: 'SET_TICKETS_FAILURE',

  SET_TICKET_SUCCESS: 'SET_TICKET_SUCCESS',
  SET_TICKET_FAILURE: 'SET_TICKET_FAILURE',

  ADD_REPLY_TICKET_SUCCESS: 'ADD_REPLY_TICKET_SUCCESS',
  ADD_REPLY_TICKET_FAILURE: 'ADD_REPLY_TICKET_FAILURE',

  CLOSE_TICKET_SUCCESS: 'CLOSE_TICKET_SUCCESS',
  CLOSE_TICKET_FAILURE: 'CLOSE_TICKET_FAILURE',

  CREATE_TICKET_SUCCESS: 'CREATE_TICKET_SUCCESS',
  CREATE_TICKET_FAILURE: 'CREATE_TICKET_FAILURE',

  SET_RATING_TICKET_SUCCESS: 'SET_RATING_TICKET_SUCCESS',
  SET_RATING_TICKET_FAILURE: 'SET_RATING_TICKET_FAILURE',
  SET_HELP_TICKET_SUCCESS: 'SET_HELP_TICKET_SUCCESS',
  SET_HELP_TICKET_FAILURE: 'SET_HELP_TICKET_FAILURE',

  MARK_TICKET_AS_READ: 'MARK_TICKET_AS_READ',
};
